import { type FetchPledgeAprData, minutesToMs, pledgeApi } from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

export const usePledgeBonusPercentageQuery = () => {
	return useQuery({
		queryFn: async () => {
			return (await pledgeApi).fetchPledgeApr() as Promise<FetchPledgeAprData>;
		},
		queryKey: ['pledge-bonus-percentage'],
		select: res => res.data,
		staleTime: minutesToMs(60)
	});
};
